export const SET_INTERVIEW_FILE_DATA = 'SET_INTERVIEW_FILE_DATA';
export const RESET_INTERVIEW_FILE_DATA = 'RESET_INTERVIEW_FILE_DATA';
